import { __rest } from "tslib";
import React from 'react';
import { classes as newColorsBrandingClasses, st, } from './newColorsBranding.st.css.js';
import { classes as madeforClasses } from './madefor.st.css.js';
import { WixDesignSystemContext } from './context';
const WixDesignSystemProvider = (_a) => {
    var { dataHook, className, as = 'span', children, theme, features = {} } = _a, rest = __rest(_a, ["dataHook", "className", "as", "children", "theme", "features"]);
    const { newColorsBranding } = features;
    const newBrandingClass = newColorsBranding && newColorsBrandingClasses.root;
    return (React.createElement(WixDesignSystemContext.Provider, { value: { newBrandingClass, newColorsBranding } }, React.createElement(as, Object.assign(Object.assign({}, rest), { 'data-hook': dataHook, 'data-newcolorsbranding': newColorsBranding, className: st(className, newBrandingClass, madeforClasses.madefor, theme === null || theme === void 0 ? void 0 : theme.className) }), children)));
};
export default WixDesignSystemProvider;
//# sourceMappingURL=WixDesignSystemProvider.js.map